var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.25 20.75L0.25 11.75C0.0625 11.5625 0 11.3125 0 11C0 10.75 0.0625 10.5 0.25 10.3125L9.25 1.3125C9.625 0.9375 10.3125 0.9375 10.6875 1.3125C11.0625 1.6875 11.0625 2.375 10.6875 2.75L3.375 10H31C31.5 10 32 10.5 32 11C32 11.5625 31.5 12 31 12H3.375L10.6875 19.3125C11.0625 19.6875 11.0625 20.375 10.6875 20.75C10.3125 21.125 9.625 21.125 9.25 20.75Z","fill":"#FF782C"}));
}

ArrowLeft.defaultProps = {"width":"32","height":"22","viewBox":"0 0 32 22","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
